/**
 * Resolves the icon path for a level from any input format.
 * Icon files live in /public/icons/ and are named icon_{level}.png.
 * This is immune to title-string format differences (short, full, or object).
 */
export const getLevelIcon = (levelInput) => {
  if (!levelInput) return null;

  const str =
    typeof levelInput === 'string'
      ? levelInput
      : levelInput.title || levelInput.id || '';

  const lower = str.toLowerCase();

  if (lower.includes('streetlight') || lower.includes('level 1')) {
    return '/icons/icon_streetlight.png';
  }
  if (lower.includes('daylight') || lower.includes('level 2')) {
    return '/icons/icon_daylight.png';
  }
  if (lower.includes('sunshield') || lower.includes('level 3')) {
    return '/icons/icon_sunshield.png';
  }

  // Fallback to whatever is stored in the object, if anything
  return (typeof levelInput === 'object' && levelInput.icon) || null;
};

/**
 * Normalizes any Firestore level value to the canonical full display string.
 *
 * Firestore may store levels in several formats depending on when they were created:
 *   - Object:  { id: 'sunshield', title: 'Sunshield', ... }
 *   - Short string: "Sunshield"
 *   - Full string: "Level 3 - Sunshield Advocate"
 *
 * All forms normalize to one of:
 *   "Level 1 - Streetlight Advocate"
 *   "Level 2 - Daylight Advocate"
 *   "Level 3 - Sunshield Advocate"
 *
 * If the input cannot be matched, it is returned as-is (or '' for null/undefined).
 * Does NOT modify Firestore data — display only.
 */
export const formatLevelDisplay = (levelInput) => {
  if (!levelInput) return '';

  const str =
    typeof levelInput === 'string'
      ? levelInput
      : levelInput.title || levelInput.id || '';

  const lower = str.toLowerCase();

  if (lower.includes('streetlight') || lower.includes('level 1')) {
    return 'Level 1 - Streetlight Advocate';
  }
  if (lower.includes('daylight') || lower.includes('level 2')) {
    return 'Level 2 - Daylight Advocate';
  }
  if (lower.includes('sunshield') || lower.includes('level 3')) {
    return 'Level 3 - Sunshield Advocate';
  }

  return str;
};
